"use client";

import { alchemyConfig } from "@shared/src/config/alchemy";
import { cookieToInitialState } from "@account-kit/core";
import { AlchemyAccountProvider } from "@account-kit/react";
import { useQueryClient } from "@tanstack/react-query";
import React, { PropsWithChildren } from "react";

const AlchemyProvider = (props: PropsWithChildren<{ cookie?: string | null }>) => {
  const queryClient = useQueryClient();
  const initialState = cookieToInitialState(alchemyConfig, props.cookie as string);
  return (
    <AlchemyAccountProvider config={alchemyConfig} queryClient={queryClient} initialState={initialState}>
      {props.children}
    </AlchemyAccountProvider>
  );
};

export default AlchemyProvider;
